export function getFieldValue(block, name) {
  return block.fieldValues.find(fv => fv.name === name);
}
export function readString(block, name) {
  var _getFieldValue$string, _getFieldValue;
  return (_getFieldValue$string = (_getFieldValue = getFieldValue(block, name)) === null || _getFieldValue === void 0 ? void 0 : _getFieldValue.stringValue) !== null && _getFieldValue$string !== void 0 ? _getFieldValue$string : '';
}
export function readNumber(block, name) {
  var _getFieldValue2;
  return (_getFieldValue2 = getFieldValue(block, name)) === null || _getFieldValue2 === void 0 ? void 0 : _getFieldValue2.numberValue;
}
export function readBoolean(block, name) {
  var _getFieldValue$boolea, _getFieldValue3;
  return (_getFieldValue$boolea = (_getFieldValue3 = getFieldValue(block, name)) === null || _getFieldValue3 === void 0 ? void 0 : _getFieldValue3.booleanValue) !== null && _getFieldValue$boolea !== void 0 ? _getFieldValue$boolea : false;
}